import 'whatwg-fetch';
import * as DOM from 'react-dom';
import AppRouter from './router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

DOM.render(
    <QueryClientProvider client={queryClient}>
        <AppRouter />
    </QueryClientProvider>,
    document.getElementById('root')
);
